export interface GetScholarshipRequest{
    scholarshipName?: string | null;
    scholarshipType?: ScholarshipType | null;
    stream?: string | null;
    level?: string | null;
    pageNumber?: number | null;
    pageSize?: number | null;
    countries?: string[] | null;
    streams?: string[] | null;
    levels?: string[] | null;
    academicEligibility?: number | null;
    fundingTypes?: string[] | null;
    gpStreams?: string[] | null;
    sortField?: string | null;
    sortOrder?: string | null;
}

export enum ScholarshipType
{
    Scholarship,
    ProfileBuilding,
    SummerSchoolIndia,
    SummerSchoolAbroad
}

export const ScholarshipTypeDescriptions: { [key in ScholarshipType]: string} = {
    [ScholarshipType.Scholarship]: "Scholarship",
    [ScholarshipType.ProfileBuilding]: "Profile Building",
    [ScholarshipType.SummerSchoolIndia]: "Summer School India",
    [ScholarshipType.SummerSchoolAbroad]: "Summer School Abroad",
}